module.exports = {"360502001":"城南街道","360502002":"城北街道","360502003":"袁河街道","360502004":"新钢街道","360502100":"水北镇","360502101":"下村镇","360502102":"良山镇","360502103":"罗坊镇","360502104":"姚圩镇","360502105":"珠珊镇","360502108":"鹄山镇","360502170":"河下镇","360502180":"观巢镇","360502181":"欧里镇","360502190":"水西镇","360502201":"人和乡","360502202":"界水乡","360502203":"南安乡","360502204":"新溪乡","360502271":"九龙山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360502.json
// module id = 1392
// module chunks = 0